module.exports = __webpack_public_path__ + "img/2018taiguo.9c91da49.png";